module.exports = __webpack_public_path__ + "static/media/watch_nav_series_3.dde995a1.svg";